import { render, staticRenderFns } from "./applySub.vue?vue&type=template&id=663c3ef4&scoped=true&"
import script from "./applySub.vue?vue&type=script&lang=js&"
export * from "./applySub.vue?vue&type=script&lang=js&"
import style0 from "./applySub.vue?vue&type=style&index=0&id=663c3ef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663c3ef4",
  null
  
)

export default component.exports